import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage, availableLanguages } = useLanguage();

  const FlagIcon: React.FC<{ code: string; className?: string }> = ({ code, className = 'w-5 h-5' }) => {
    if (code === 'fr') {
      return (
        <svg className={className} viewBox="0 0 640 480" xmlns="http://www.w3.org/2000/svg">
          <g fillRule="evenodd" strokeWidth="1pt">
            <path fill="#fff" d="M0 0h640v480H0z"/>
            <path fill="#002654" d="M0 0h213.3v480H0z"/>
            <path fill="#ce1126" d="M426.7 0H640v480H426.7z"/>
          </g>
        </svg>
      );
    }
    if (code === 'en') {
      // Union Jack - Drapeau actuel du Royaume-Uni
      return (
        <svg className={className} viewBox="0 0 640 480" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <clipPath id="uk-flag-clip">
              <path d="M0 0h640v480H0z"/>
            </clipPath>
          </defs>
          <g clipPath="url(#uk-flag-clip)">
            {/* Fond bleu */}
            <rect width="640" height="480" fill="#012169"/>
            {/* Croix blanche de Saint-André (diagonales) */}
            <path fill="#fff" d="M0 0l640 480M640 0L0 480" stroke="#fff" strokeWidth="96" strokeLinecap="square"/>
            {/* Croix rouge de Saint-André (diagonales) */}
            <path fill="#C8102E" d="M0 0l640 480M640 0L0 480" stroke="#C8102E" strokeWidth="64" strokeLinecap="square"/>
            {/* Croix blanche de Saint-Georges (verticale et horizontale) */}
            <rect x="0" y="200" width="640" height="80" fill="#fff"/>
            <rect x="280" y="0" width="80" height="480" fill="#fff"/>
            {/* Croix rouge de Saint-Georges (verticale et horizontale) */}
            <rect x="0" y="220" width="640" height="40" fill="#C8102E"/>
            <rect x="300" y="0" width="40" height="480" fill="#C8102E"/>
          </g>
        </svg>
      );
    }
    return null;
  };

  return (
    <div className="relative group">
      <button className="flex items-center gap-2 px-3 py-2 rounded-lg bg-gray-800/50 border border-gray-700/50 hover:border-primary-500/50 transition-all hover:scale-105">
        <FlagIcon code={language} className="w-5 h-5 rounded-sm" />
        <span className="text-sm text-gray-300 font-medium">{availableLanguages.find(l => l.code === language)?.name}</span>
        <i className="bx bx-chevron-down text-gray-400 text-sm"></i>
      </button>
      
      <div className="absolute top-full right-0 mt-2 w-48 bg-gray-800/95 backdrop-blur-md border-2 border-gray-700/50 rounded-lg shadow-2xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50 overflow-hidden">
        {availableLanguages.map((lang) => (
          <button
            key={lang.code}
            onClick={() => setLanguage(lang.code)}
            className={`w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-gray-700/50 transition-colors ${
              language === lang.code ? 'bg-primary-500/20 border-l-2 border-primary-500' : ''
            }`}
          >
            <FlagIcon code={lang.code} className="w-5 h-5 rounded-sm flex-shrink-0" />
            <span className="text-gray-300 flex-1">{lang.name}</span>
            {language === lang.code && (
              <i className="bx bx-check text-primary-400 text-lg"></i>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default LanguageSwitcher;

